import {Hydra} from '../generic/hydra';

import {FieldParamInterface} from './FieldParam';
import {FieldParamValue as FieldParamValueBaseInterface} from '../../interface/api/FieldParamValue';

export type FieldParamValueInterface = FieldParamValueBaseInterface;

export class FieldParamValue extends Hydra implements FieldParamValueInterface {

    id?: number | null;

    fieldParam?: FieldParamInterface | string | null;

    value?: string | null;


    constructor(options: FieldParamValueInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
